import api from '../../axios_api'
import _ from 'lodash'
import Promise from 'bluebird'
import router from '../../main'
import { json } from 'd3'


const state = {
    summaryData: {},
    detailsData: [],
    thesisData: {},
    capitalCallData: [],
    distributionData: [],
    lpDocuments: []
}

const buildFormData = function (payload) {
    let formData = new FormData();  /*
        Add the form data we need to submit
    */
    for (var i = 0; i < payload.files.length; i++) {
        let file = payload.files[i];

        if (!file) {
            file = new Blob(['test'], { type: "text/plain;charset=utf-8" });
        }

        formData.append(
            'files[' + i + ']',
            file,
            (file ? file.name : '')
        );
    }
    formData.append('encrypt', JSON.stringify({ encrypt: { data: payload.data } }));

    return formData;
}

const getters = {
    summaryData: function (state) {
        // let retval = [];
        // if (state.summaryData && state.summaryData._id) {
        //     retval.push(state.summaryData);
        // }
        return state.summaryData;
    },
    detailsData: function (state) {
        return state.detailsData;
    },
    thesisData: function (state) {
        return state.thesisData;
    },
    lpDetailsData: function (state) {
        let data = state.detailsData;
        let retval = _.filter(data, function (obj) {
            return obj && obj.hasOwnProperty('entity_type') && obj.entity_type.length > 0 && obj.entity_type == 'LP'
        });
        retval.map((item, index) => {
            if (item) {
                item.indexNumber = index + 1
            }
        });
        return retval;
    },
    gpDetailsData: function (state) {
        let retval = state.detailsData;
        return _.filter(retval, function (obj) {
            return obj && obj.hasOwnProperty('entity_type') && obj.entity_type.length > 0 && obj.entity_type != 'LP'
        })
    },
    fundDetailsData: function (state) {
        let fundObj = {
            entity_name: 'FUND TOTALS',
            entity_type: '',
            ownership: 0,
            capital_commitment: 0,
            capital_called: 0,
            open_balance: 0,
            remaining_commitment: 0,
            contributed_to_date: 0,
            distributions: 0,
            profit: 0,
            lp_percentage: 0,
            handle_menu: ''
        };
        let detailsData = JSON.parse(JSON.stringify(state.detailsData));
        detailsData.map((item) => {
            if (item.hasOwnProperty('capital_commitment') && Number(item.capital_commitment) > 0) {
                fundObj.capital_commitment += Number(item.capital_commitment);
            }
            if (item.hasOwnProperty('capital_called') && Number(item.capital_called) > 0) {
                fundObj.capital_called += Number(item.capital_called);
            }
            if (item.hasOwnProperty('open_balance') && Number(item.open_balance)) {
                fundObj.open_balance += Number(item.open_balance);
            }
            if (item.hasOwnProperty('remaining_commitment') && Number(item.remaining_commitment) > 0) {
                fundObj.remaining_commitment += Number(item.remaining_commitment);
            }
            if (item.hasOwnProperty('contributed_to_date') && Number(item.contributed_to_date) > 0) {
                fundObj.contributed_to_date += Number(item.contributed_to_date);
            }
            if (item.hasOwnProperty('distributions') && Number(item.distributions) > 0) {
                fundObj.distributions += Number(item.distributions);
            }
            if (item.hasOwnProperty('lp_percentage') && Number(item.lp_percentage) > 0) {
                fundObj.lp_percentage += Number(item.lp_percentage);
            }
            if (item.hasOwnProperty('profit') && Number(item.profit) > 0) {
                fundObj.profit += Number(item.profit);
            }
            if (item.hasOwnProperty('ownership') && Number(item.ownership) > 0) {
                fundObj.ownership += Number(item.ownership);
            }
        });
        let retval = [];
        retval.push(fundObj);
        return retval;
    },
    capitalCallData: function (state) {
        let retval = JSON.parse(JSON.stringify(state.capitalCallData));
        retval.map((item, index) => {
            if (item) {
                if (index == 0) {
                    item.showEllipses = true;
                }
                else {
                    item.showEllipses = false;
                }
            }
        })
        return retval;
    },
    distributionData: function (state) {
        let retval = JSON.parse(JSON.stringify(state.distributionData));
        retval.map((item, index) => {
            if (item) {
                if (index == 0) {
                    item.showEllipses = true;
                }
                else {
                    item.showEllipses = false;
                }
            }
        })
        return retval;
    },
    currentCapitalCallData: function (state) {
        let retval = state.capitalCallData && state.capitalCallData.length > 0 && state.capitalCallData[0] ? state.capitalCallData[0] : {};
        return retval;
    },
    currentDistributionData: function (state) {
        let retval = state.distributionData && state.distributionData.length > 0 && state.distributionData[0] ? state.distributionData[0] : {};
        return retval;
    },
    lpDocuments: function (state, getters, rootState, rootGetters) {
        let retval = JSON.parse(JSON.stringify(state.lpDocuments));
        if (retval.length == 0) {
            return retval;
        }
        let lpDetails = getters['lpDetailsData'];
        let lpDetailsData = lpDetails && lpDetails.length > 0 ? JSON.parse(JSON.stringify(lpDetails)) : [];
        retval = retval.filter((item) => {
            if (item) {
                if (item.lp_item && item.hasOwnProperty('entity_type') && item.entity_type == 'LP' && !item.hasOwnProperty('is_entity_deleted')) {
                    item.lpDetails = lpDetailsData.find((lpItem) => {
                        if (lpItem && lpItem.hasOwnProperty('_id') && lpItem._id == item.lp_item) {
                            return lpItem;
                        }
                    });
                    item.date = item.date ?
                        item.date
                        : item.hasOwnProperty('created')
                            ? item.created : new Date();
                    return item;
                }
            }
        });
        return retval.sort((a, b) => {
            return new Date(a.date) - new Date(b.date);
        })
    },
    formationDocuments: function (state) {
        let retval = JSON.parse(JSON.stringify(state.lpDocuments));
        if (retval.length == 0) {
            return retval;
        }
        retval = retval.filter((item) => {
            if (item) {
                if (item.hasOwnProperty('entity_type') && item.entity_type == 'GP') {
                    item.date = item.date ?
                        item.date
                        : item.hasOwnProperty('created')
                            ? item.created : new Date();
                    return item;
                }
            }
        });
        return retval.sort((a, b) => {
            return new Date(a.date) - new Date(b.date);
        })
    },
    archievedDocuments: function (state, getters, rootState, rootGetters) {
        let retval = JSON.parse(JSON.stringify(state.lpDocuments));
        if (retval.length == 0) {
            return retval;
        }
        let lpDetails = getters['lpDetailsData'];
        let lpDetailsData = lpDetails && lpDetails.length > 0 ? JSON.parse(JSON.stringify(lpDetails)) : [];
        retval = retval.filter((item) => {
            if (item) {
                if (item.lp_item && item.hasOwnProperty('entity_type') && item.entity_type == 'LP' && item.hasOwnProperty('is_entity_deleted') && item.is_entity_deleted) {
                    item.lpDetails = lpDetailsData.find((lpItem) => {
                        if (lpItem && lpItem.hasOwnProperty('_id') && lpItem._id == item.lp_item) {
                            return lpItem;
                        }
                    });
                    item.date = item.date ?
                        item.date
                        : item.hasOwnProperty('created')
                            ? item.created : new Date();
                    return item;
                }
            }
        });
        return retval.sort((a, b) => {
            return new Date(a.date) - new Date(b.date);
        })
    },
}

const mutations = {
    initialize(state) {
        state.summaryData = [];
        state.detailsData = [];
        state.thesisData = {};
        state.capitalCallData = [];
        state.distributionData = [];
        state.lpDocuments = [];
    },
    summaryMerge(state, payload) {
        if (_.isNil(payload) || _.isEmpty(payload)) return
        state.summaryData = payload
    },
    detailsMerge(state, payload) {
        if (_.isNil(payload) || _.isEmpty(payload)) return
        if (!_.isArray(payload)) payload = [payload]
        state.detailsData = _.map(state.detailsData, addr => {
            let index = _.findIndex(payload, function (a) { return a._id === addr._id })
            if (index >= 0) {
                return _.first(_.pullAt(payload, index))
            }
            return addr
        })
        if (!_.isEmpty(payload)) state.detailsData = _.concat(state.detailsData, payload)
        state.detailsData = _.without(state.detailsData, null, undefined)
    },
    remove(state, payload) {
        if (_.isNil(payload) || _.isEmpty(payload)) return
        state.detailsData = _.filter(state.detailsData, function (a) { return a._id !== payload })
    },
    setThesisData(state, payload) {
        state.thesisData = payload;
    },
    capitalCallMerge(state, payload) {
        // if (_.isNil(payload) || _.isEmpty(payload)) return
        state.capitalCallData = payload;
    },
    distributionMerge(state, payload) {
        // if (_.isNil(payload) || _.isEmpty(payload)) return
        state.distributionData = payload;
    },
    lpDocumentsMerge(state, payload) {
        state.lpDocuments = payload;
    }
}
const actions = {
    start({ state, dispatch, commit }) {
        commit('initialize')
        dispatch('apiFetchSummaryData');
        dispatch('apiFetchDetailsData');
        dispatch('apiFetchThesisData');
        dispatch('apiFetchCapitalCallData');
        dispatch('apiFetchDistributionData');
        dispatch('apiFetchlpDocumentsData');
    },
    stop({ commit }) {
        // clean up
        commit('initialize')
    },
    apiFetchSummaryData({ commit }, payload) {
        if (localStorage.fiifi) {
            let fiifi = JSON.parse(localStorage.fiifi).user
            if (fiifi && fiifi.workspace_id && fiifi.workspace_id.length > 0) {
                let url = `/${fiifi.id}/${fiifi.workspace_id}/lpsummary`;
                return api.get(url)
                    .then(res => {
                        commit('summaryMerge', res.data.encrypt.success)
                        return Promise.resolve(res.data.encrypt.success)
                    })
                    .catch(err => {
                        return Promise.reject(err)
                    })
            }
        }
    },
    apiFetchDetailsData({ commit }, payload) {
        if (localStorage.fiifi) {
            let fiifi = JSON.parse(localStorage.fiifi).user
            if (fiifi && fiifi.workspace_id && fiifi.workspace_id.length > 0) {
                let url = `/${fiifi.id}/${fiifi.workspace_id}/lpDetails`;
                return api.get(url)
                    .then(res => {
                        commit('detailsMerge', res.data.encrypt.success)
                        return Promise.resolve(res.data.encrypt.success)
                    })
                    .catch(err => {
                        return Promise.reject(err)
                    })
            }
        }
    },
    apiFetchThesisData({ commit }, payload) {
        if (localStorage.fiifi) {
            let fiifi = JSON.parse(localStorage.fiifi).user
            if (fiifi && fiifi.workspace_id && fiifi.workspace_id.length > 0) {
                let url = `/${fiifi.workspace_id}/thesis`;
                return api.get(url)
                    .then(res => {
                        commit('setThesisData', res.data.encrypt.success)
                    })
                    .catch(err => {
                        return Promise.reject(err)
                    })
            }
        }
    },
    apiPostSummaryData({ dispatch, commit }, payload) {
        let workspace = router.currentRoute.params.workspace_id;
        if (payload && payload.hasOwnProperty('workspace')) {
            workspace = payload.workspace;
            delete payload.workspace;
        }
        let url = `${router.currentRoute.params.account_id}/${workspace}/lpsummary`;
        return api.post(url, { encrypt: { data: payload } })
            .then(res => {
                commit('summaryMerge', res.data.encrypt.success)
                return Promise.resolve(res.data.encrypt.success)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiPostDetailsData({ dispatch, commit }, payload) {
        let workspace = router.currentRoute.params.workspace_id;
        if (payload && payload.hasOwnProperty('workspace')) {
            workspace = payload.workspace;
            delete payload.workspace;
        }
        let url = `${router.currentRoute.params.account_id}/${workspace}/lpDetails`;
        return api.post(url, { encrypt: { data: payload } })
            .then(res => {
                commit('detailsMerge', res.data.encrypt.success)
                return Promise.resolve(res.data.encrypt.success)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiPatchDetailsData({ dispatch, commit }, payload) {
        let url = `/${payload._id}/${payload.workspace}/lpDetails`;
        return api.patch(url, { encrypt: { data: payload } })
            .then(res => {
                commit('detailsMerge', res.data.encrypt.success)
                return Promise.resolve(res.data.encrypt.success)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiBulkPatchDetailsData({ dispatch, commit }, payload) {
        let workspace = router.currentRoute.params.workspace_id;
        if (!workspace && payload && payload.length > 0) {
            workspace = payload[0].workspace ? payload[0].workspace : "";
            delete payload.workspace;
        }
        let url = `${router.currentRoute.params.account_id}/${workspace}/bulk/lpDetails`;
        return api.post(url, { encrypt: { data: payload } })
            .then(res => {
                commit('detailsMerge', res.data.encrypt.success)
                return Promise.resolve(res.data.encrypt.success)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiDeleteDetails({ dispatch, commit }, payload) {
        let url = `/${payload._id}/lpDetails`;
        return api.delete(url)
            .then(res => {
                commit('remove', payload._id);
                return Promise.resolve(res.data.encrypt)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiPatchSummaryData({ dispatch, commit }, payload) {
        let workspace = router.currentRoute.params.workspace_id;
        if (payload && payload.hasOwnProperty('workspace')) {
            workspace = payload.workspace;
            delete payload.workspace;
        }
        let url = `${router.currentRoute.params.account_id}/${workspace}/${payload._id}/edit/lpsummary`;
        return api.post(url, { encrypt: { data: payload } })
            .then(res => {
                commit('summaryMerge', res.data.encrypt.success)
                return Promise.resolve(res.data.encrypt.success)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiBulkPostDetailsData({ dispatch, commit }, payload) {
        let workspace = router.currentRoute.params.workspace_id;
        if (!workspace && payload && payload.length > 0) {
            workspace = payload[0].workspace ? payload[0].workspace : "";
            delete payload.workspace;
        }
        let url = `${router.currentRoute.params.account_id}/${workspace}/bulk/insert/lpDetails`;
        return api.post(url, { encrypt: { data: payload } })
            .then(res => {
                commit('detailsMerge', res.data.encrypt.success)
                return Promise.resolve(res.data.encrypt.success)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiFetchCapitalCallData({ commit }, payload) {
        if (localStorage.fiifi) {
            let fiifi = JSON.parse(localStorage.fiifi).user
            if (fiifi && fiifi.workspace_id && fiifi.workspace_id.length > 0) {
                let url = `/${fiifi.workspace_id}/capitalCall`;
                return api.get(url)
                    .then(res => {
                        commit('capitalCallMerge', res.data.encrypt.success);
                        return Promise.resolve(res.data.encrypt.success);
                    })
                    .catch(err => {
                        return Promise.reject(err);
                    })
            }
        }
    },
    apiPostCapitalCallData({ dispatch, commit }, payload) {
        let workspace = router.currentRoute.params.workspace_id;
        if (payload && payload.hasOwnProperty('workspace')) {
            workspace = payload.workspace;
            delete payload.workspace;
        }
        let url = `${router.currentRoute.params.account_id}/${workspace}/capitalCall`;
        return api.post(url, { encrypt: { data: payload } })
            .then(res => {
                commit('capitalCallMerge', res.data.encrypt.success)
                return Promise.resolve(res.data.encrypt.success)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiPatchCapitalCallData({ dispatch, commit }, payload) {
        let workspace = router.currentRoute.params.workspace_id;
        if (payload && payload.hasOwnProperty('workspace')) {
            workspace = payload.workspace;
            delete payload.workspace;
        }
        let url = `${router.currentRoute.params.account_id}/${workspace}/${payload._id}/capitalCall`;
        return api.patch(url, { encrypt: { data: payload } })
            .then(res => {
                commit('capitalCallMerge', res.data.encrypt.success)
                return Promise.resolve(res.data.encrypt.success)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiDeleteCapitalCallData({ dispatch, commit }, payload) {
        let url = `/${payload._id}/capitalCall`;
        return api.delete(url, {})
            .then((response) => {
                return Promise.resolve(response.data.encrypt.success)
            })
            .catch((error) => {
                return Promise.reject(error)
            })
    },
    apiFetchDistributionData({ commit }, payload) {
        if (localStorage.fiifi) {
            let fiifi = JSON.parse(localStorage.fiifi).user
            if (fiifi && fiifi.workspace_id && fiifi.workspace_id.length > 0) {
                let url = `/${fiifi.workspace_id}/distribution`;
                return api.get(url)
                    .then(res => {
                        commit('distributionMerge', res.data.encrypt.success)
                        return Promise.resolve(res.data.encrypt.success)
                    })
                    .catch(err => {
                        return Promise.reject(err)
                    })
            }
        }
    },
    apiPostDistributionData({ dispatch, commit }, payload) {
        let workspace = router.currentRoute.params.workspace_id;
        if (payload && payload.hasOwnProperty('workspace')) {
            workspace = payload.workspace;
            delete payload.workspace;
        }
        let url = `${router.currentRoute.params.account_id}/${workspace}/distribution`;
        return api.post(url, { encrypt: { data: payload } })
            .then(res => {
                commit('distributionMerge', res.data.encrypt.success)
                return Promise.resolve(res.data.encrypt.success)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiPatchDistributionData({ dispatch, commit }, payload) {
        let workspace = router.currentRoute.params.workspace_id;
        if (payload && payload.hasOwnProperty('workspace')) {
            workspace = payload.workspace;
            delete payload.workspace;
        }
        let url = `${router.currentRoute.params.account_id}/${workspace}/${payload._id}/distribution`;
        return api.patch(url, { encrypt: { data: payload } })
            .then(res => {
                commit('distributionMerge', res.data.encrypt.success)
                return Promise.resolve(res.data.encrypt.success)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiDeleteDistributionData({ dispatch, commit }, payload) {
        let url = `/${payload._id}/distribution`;
        return api.delete(url, {})
            .then((response) => {
                return Promise.resolve(response.data.encrypt.success)
            })
            .catch((error) => {
                return Promise.reject(error)
            })
    },
    apiFetchlpDocumentsData({ commit }, payload) {
        if (localStorage.fiifi) {
            let fiifi = JSON.parse(localStorage.fiifi).user
            if (fiifi && fiifi.workspace_id && fiifi.workspace_id.length > 0 && fiifi.id && fiifi.id.length > 0) {
                let url = `${fiifi.id}/${fiifi.workspace_id}/lpDocument`;
                return api.get(url)
                    .then(res => {
                        commit('lpDocumentsMerge', res.data.encrypt.success);
                        return Promise.resolve(res.data.encrypt.success);
                    })
                    .catch(err => {
                        return Promise.reject(err);
                    })
            }
        }
    },
    apiPostLpDocument({ commit }, payload) {
        if (_.isNil(payload) || _.isEmpty(payload)) return Promise.reject({ error: 'no arguments' })
        let formData = buildFormData(payload);
        let url = `${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/lpDocument`;
        return api.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(res => {
                return Promise.resolve(res)
            })
            .catch(err => {
                console.error(`Error during lp document upload: ${err}`)
                return Promise.reject(err)
            })
    },
    apiPostAdditionalFundData({ commit }, payload) {
        if (_.isNil(payload) || _.isEmpty(payload)) return Promise.reject({ error: 'no arguments' })
        let url = `${router.currentRoute.params.account_id}/${payload.workspace_id}/fund_data`;
        return api.post(url, { encrypt: { data: payload } })
            .then(res => {
                return Promise.resolve(res)
            })
            .catch(err => {
                console.error(`Error during lp document upload: ${err}`)
                return Promise.reject(err)
            })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}